import React from 'react'
import Logo from '../assets/logo.svg'

const navbar = () => {
  return (
    <div>
    <div className=' flex p-5  mx-[5rem] gap-[30rem] sm:mx-[0.1px] px-3 sm:pt-3'>
    
      <div className='text-xl flex text-black rounded-[16.151px] bg-white shadow-lg font-inter font-extrabold italic p-4 w-[222.075px] h-[63.796px] flex-shrink-0 sm:w-[137px] sm:h-[39.356px] sm:text-[10px] sm:p-2  sm:gap-[5px]'>
      <img
        src={Logo}
        alt="image"
        className="w-7 h-7 object-cover"
      /><p className='sm:mb-2'>HUMANIZED AI</p></div>
      <div className='text-xl text-black p-5 flex gap-[5rem] sm:hidden md:hidden'>
        <div className='text-[20px] font-inter font-semibold flex gap-[2rem]'>
        <a>Home</a>
        <a>Twitter</a>
        <a>Telegram</a>
        <a>Twitter</a>
        <a>Whitepaper</a>
        </div>
        
        <div className='rounded-[50px] text-white flex items-center justify-center  w-[8rem] bg-[#A900FF] text-[15px] p-[7px] font-inter font-bold'>Buy Now</div>
      </div>
    </div>
  </div>
  )
}

export default navbar
